import { Trash, Edit } from '@styled-icons/boxicons-solid'

import { formatEmptyValue } from '../../../utils/common'
import Tooltip from '../../common/tooltip'

const WireRows = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-1 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-2/12 items-center table_text">
          <Tooltip message={props?.harness?.harness_id}>
            <div>{formatEmptyValue(props?.harness?.harness_id)}</div>
          </Tooltip>
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text">
          <Tooltip message={props?.circuit?.name}>
            <div>{formatEmptyValue(props?.circuit?.name)}</div>
          </Tooltip>
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text text-sm">
          <Tooltip message={`${props?.pin_from}/${props.pin_to}`}>
            <div>
              {props?.pin_from} / {props?.pin_to}
            </div>
          </Tooltip>
        </div>
        <div className="flex w-4/12 pl-6 items-center table_text text-sm">
          <Tooltip
            message={`${props?.connector_from?.name}/${props?.connector_to?.name}`}
          >
            <div>
              <span className="font-bold">From : </span>{' '}
              {props?.connector_from?.name}{' '}
              <span className="font-bold">To :</span>
              {props?.connector_to?.name}
            </div>
          </Tooltip>
        </div>
        <div className="flex w-2/12 pl-6 items-center justify-end">
          <span
            onClick={() => {
              props.onShowDetails()
            }}
            className="cursor-pointer px-1"
          >
            <Edit size="2rem" color="#0189E9" />
          </span>
          <span
            onClick={() => {
              props.onDelete()
            }}
            className="cursor-pointer px-1"
          >
            <Trash size="2rem" color="#0189E9" />
          </span>
        </div>
      </div>
    </div>
  )
}

export default WireRows
